import { JobContentElementController } from '@sas-dvr/ltjs-bird';
import { merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { JobContentState } from '@sas-dvr/internal-va-react-core/store/birdElement/jobContentState';
import { fromPortableEvent } from '../util';
import { VisualElementControllerLoader } from './LoaderFactory';
import { loadVisualElementController } from './loadVisualElement';

export const loadJobContentElementController: VisualElementControllerLoader = (
  visualController,
  visualElementController,
  unload$,
  myActions$,
  state$,
  deps
) => {
  if (!(visualElementController instanceof JobContentElementController)) {
    throw new Error('Expected the controller to be a JobContentElementController');
  }

  const id = deps.getKey(visualElementController);

  return merge(
    //
    // VisualElement load
    //
    loadVisualElementController(
      visualController,
      visualElementController,
      unload$,
      myActions$,
      state$,
      deps,
      {
        create: () =>
          JobContentState.actions.add(id, {
            jobResultsUri: visualElementController.getJobResultsUri() || undefined,
          }),
        delete: () => JobContentState.actions.delete(id),
      }
    ),
    //
    // Set jobResultsUri when controller is ready.
    //
    fromPortableEvent(visualElementController, JobContentElementController.READY).pipe(
      map(() =>
        JobContentState.actions.setJobResultsUri(
          id,
          visualElementController.getJobResultsUri() || undefined
        )
      )
    )
  );
};
